import { useState } from "react";
import InputField from "../InputField/InputField";

const ScoredInputRow = ({
  accreditation,
  className,
  selectedValue,
  points,
  onAnswerChange,
  showPointsField = true,
  disabled,
}) => {
  const options = accreditation
    ? [
        { label: "NA", value: "NA" },
        { label: "NC", value: "NC" },
        { label: "C", value: "C" },
      ]
    : [
        { label: "Y", value: "Y" },
        { label: "P", value: "P" },
        { label: "N", value: "N" },
        { label: "NA", value: "NA" },
      ];
  const handleSelectChange = (e) => {
    const value = e.target.value;
    onAnswerChange(value, undefined, points);
  };

  const handlePointsChange = (e) => {
    const val = e.target.value;
    onAnswerChange(selectedValue, undefined, val);
  };

  // document.addEventListener(
  //   "wheel",
  //   function (event) {
  //     if (document.activeElement.type === "number") {
  //       event.preventDefault();
  //     }
  //   },
  //   { passive: false }
  // );

  return (
    <div className="row g-2">
      <div className="col-md-6 col-12">
        <InputField
          dropdownOptions={options}
          dropdownClass={`flex-fill ${className}`}
          value={selectedValue}
          onChange={handleSelectChange}
          placeholder="Select an option"
          disabled={disabled}
        />
      </div>
      {showPointsField && (
        <div className="col-md-6 col-12">
          <input
            className={`form-control ${className}`}
            placeholder="Enter points"
            onwheel="this.blur()"
            min="0"
            type="number"
            value={points}
            onChange={handlePointsChange}
            disabled={disabled}
          />
        </div>
      )}
    </div>
  );
};

export default ScoredInputRow;
